export const ENDPOINT = (address_id: string) => `api/app/addresses/${address_id}`;

export type EditUserAddressRequest = Partial<{
  street: string;
  number: string;
  complement: string;
  reference: string;
  district: string;
  city: string;
  state: string;
  cep: string;
  latitude: number;
  longitude: number;
}>;

export type EditUserAddressResponse = {
  id: string;
  street: string;
  number: string;
  complement?: string;
  reference?: string;
  district: string;
  city: string;
  state: string;
  cep: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
};
